import React, { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default class SearchForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      staff_id: "",
      first_last_name: "",
      hiragana_name: "",
      status: "",
      transfer_at: null,
      from_date: null,
      to_date: null,
    };
    this.handleChangeTransferAt = this.handleChangeTransferAt.bind(this);
    this.handleChangeFromDate = this.handleChangeFromDate.bind(this);
    this.handleChangeToDate = this.handleChangeToDate.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleSearchData = this.handleSearchData.bind(this);
    this.resetInputField = this.resetInputField.bind(this);
  }

  /**
   * Call search data by text
   */
  handleSearchData() {
    const searchForm = {
      id: this.state.id,
      staff_id: this.state.staff_id,
      first_last_name: this.state.first_last_name,
      hiragana_name: this.state.hiragana_name,
      status: this.state.status,
      transfer_at: this.state.transfer_at
        ? this.state.transfer_at.format("YYYY-MM-DD")
        : "",
      from_date: this.state.from_date
        ? this.state.from_date.format("YYYY-MM-DD HH:mm")
        : "",
      to_date: this.state.to_date
        ? this.state.to_date.format("YYYY-MM-DD HH:mm")
        : "",
      page: 1,
    };
    if (typeof this.props.onSearch === "function") {
      this.props.onSearch(searchForm);
    }
  }

  /**
   * Process change transfer at
   */
  handleChangeTransferAt(date) {
    this.setState({
      transfer_at: date,
    });
  }

  /**
   * Process created date from
   */
  handleChangeFromDate(date) {
    this.setState({
      from_date: date,
    });
  }

  /**
   * Process create date to
   */
  handleChangeToDate(date) {
    this.setState({
      to_date: date,
    });
  }

  /**
   * Process field change
   */
  handleFieldChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  /**
   * Clear data input field
   */
  resetInputField() {
    this.setState({
      id: "",
      staff_id: "",
      first_last_name: "",
      hiragana_name: "",
      status: "",
      transfer_at: null,
      from_date: null,
      to_date: null,
    });
  }

  render() {
    return (
      <div className="collapse multi-collapse" id="search-transfers">
        <div className="card mt-3">
          <div className="card-header">銀行振込申請を検索する条件</div>
          <div className="card-body">
            <div className="row">
              <div className="col-sm-4">
                <div className="form-group">
                  <label className="form-label">ID</label>
                  <input
                    type="text"
                    name="id"
                    onChange={this.handleFieldChange}
                    value={this.state.id}
                    className="form-control"
                    placeholder="ID"
                  />
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label className="form-label">ワーカーID</label>
                  <input
                    type="text"
                    name="staff_id"
                    onChange={this.handleFieldChange}
                    value={this.state.staff_id}
                    className="form-control"
                    placeholder="ワーカーID"
                  />
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label className="form-label">ワーカー名</label>
                  <input
                    type="text"
                    name="first_last_name"
                    onChange={this.handleFieldChange}
                    value={this.state.first_last_name}
                    className="form-control"
                    placeholder="ワーカー名"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-4">
                <div className="form-group">
                  <label className="form-label">ワーカー名（カナ）</label>
                  <input
                    type="text"
                    name="hiragana_name"
                    onChange={this.handleFieldChange}
                    value={this.state.hiragana_name}
                    className="form-control"
                    placeholder="ワーカー名（カナ）"
                  />
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label className="form-label">ステータス</label>
                  <select
                    className="form-control"
                    name="status"
                    value={this.state.status}
                    onChange={this.handleFieldChange}
                  >
                    <option value="all">すべて</option>
                    <option value="4">振込済み</option>
                    <option value="1">振込中</option>
                    <option value="5">振込エラー</option>
                  </select>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    振込日
                  </label>
                  <div className="input-group">
                    <DatePicker
                      locale="ja-JP"
                      className="form-control form_datepicker"
                      dateFormat="YYYY/MM/DD"
                      selected={this.state.transfer_at}
                      onChange={this.handleChangeTransferAt}
                      placeholderText="振込日"
                      disabledKeyboardNavigation
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        id="form-calendar"
                      >
                        <i className="material-icons">calendar_today</i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-4">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    申請開始日
                  </label>
                  <div className="input-group">
                    <DatePicker
                      locale="ja-JP"
                      className="form-control form_datepicker"
                      dateFormat="YYYY/MM/DD HH:mm"
                      selected={this.state.from_date}
                      onChange={this.handleChangeFromDate}
                      showTimeSelect
                      timeFormat="HH:mm"
                      timeIntervals={15}
                      timeCaption="時間"
                      placeholderText="申請開始日"
                      disabledKeyboardNavigation
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        id="form-calendar"
                      >
                        <i className="material-icons">calendar_today</i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    申請終了日
                  </label>
                  <div className="input-group">
                    <DatePicker
                      locale="ja-JP"
                      className="form-control form_datepicker"
                      dateFormat="YYYY/MM/DD HH:mm"
                      minDate={this.state.from_date}
                      selected={this.state.to_date}
                      onChange={this.handleChangeToDate}
                      showTimeSelect
                      timeFormat="HH:mm"
                      timeIntervals={15}
                      timeCaption="時間"
                      placeholderText="申請終了日"
                      disabledKeyboardNavigation
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        id="form-calendar"
                      >
                        <i className="material-icons">calendar_today</i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer text-center">
            <button
              type="reset"
              className="btn btn-light"
              onClick={this.resetInputField}
            >
              リセット
            </button>
            <button
              onClick={this.handleSearchData}
              type="submit"
              className="btn btn-secondary"
            >
              検索する
            </button>
          </div>
        </div>
      </div>
    );
  }
}
